import classes from "./checkBox.module.scss";

interface Props<T, K extends keyof T> {
  label: string;
  identifier: K;
  placeholder?: string;
  onChange: (identifier: K, value: boolean) => void;
  defaultChecked?: boolean;
  checked?: boolean;
}

const CheckBox = <T, K extends keyof T>({
  identifier,
  onChange,
  label,
  defaultChecked,
  checked,
}: Props<T, K>) => {
  return (
    <label className={classes.checkBoxContainer}>
      {label}
      <input
        type="checkbox"
        className={classes.checkBox}
        onChange={(event) => {
          onChange(identifier, event.target.checked);
        }}
        defaultChecked={defaultChecked}
        checked={checked}
      />
      <span className={classes.checkmark}>
        <span className={classes.arrow}></span>
      </span>
    </label>
  );
};

export default CheckBox;
